
<template>

	<b-overlay class="main-container" :show="wait" v-if="data">

		<b-navbar class="p-0 mb-3">

			<b-navbar-brand class="p-0">
				<div class="d-flex align-items-center" style="gap: .75rem;">
					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>

					<h3>Объект-аналог {{ data.current_version.attrs.group_code }}</h3>
				</div>
			</b-navbar-brand>

		</b-navbar>
		<b-row class="my-2">

			<b-col>Группа: <router-link :to="'/group_statistic/' + data.current_version.group.id">{{ data.current_version.group.full_name }}</router-link></b-col>

		</b-row>
		<attrs class="main-container_content" :data="data.current_version.attrs" :attrs="attrs"/>
		
	</b-overlay>

</template>

<script>

import api from "../../../api"
import attrs from "../base_objects/object/attrs"

export default
{
	components :
	{
		attrs,
	},

	data()
	{
		return {

			service : "cadastral_analogues",

			id : null,
			data : null,

			attrs : [],

			wait : false,
    
		}
	},

	mounted() 
	{
		this.wait = true
		this.id = this.$route.params.id

		return api.call(this, "cadastral_attrs", "get_many", {}, response => { this.attrs = api.sort_objects_array_by_key(response.data, "name") })
			.then(() => this.refresh())
	},

	methods :
	{
		refresh()
		{
			this.wait = true

			api.call(this, this.service, "get", { id : this.id },
				response =>
				{
					this.data = response.data

					if(this.$refs.version)
						this.$refs.version.refresh(this.data.current_version)

					this.wait = false
				})
		},

		go_back()
		{
			api.back.go(this)
		},
	}
}

</script>

